/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Resume_Upload_TitleInputs */

const en_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Existing Resume`)
};

const de_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestehenden Lebenslauf hochladen`)
};

const fr_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger un CV existant`)
};

const es_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir currículum existente`)
};

const it_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica il Tuo Curriculum Esistente`)
};

const nl_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload bestaand CV`)
};

const pl_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wgraj istniejące CV`)
};

const fi_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa Olemassa Oleva Ansioluettelo`)
};

const da_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload eksisterende CV`)
};

const sv_onboarding_resume_upload_title = /** @type {(inputs: Onboarding_Resume_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp befintligt CV`)
};

/**
* | output |
* | --- |
* | "Upload Existing Resume" |
*
* @param {Onboarding_Resume_Upload_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_resume_upload_title = /** @type {((inputs?: Onboarding_Resume_Upload_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Resume_Upload_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_resume_upload_title(inputs)
	if (locale === "fr") return fr_onboarding_resume_upload_title(inputs)
	if (locale === "es") return es_onboarding_resume_upload_title(inputs)
	if (locale === "it") return it_onboarding_resume_upload_title(inputs)
	if (locale === "nl") return nl_onboarding_resume_upload_title(inputs)
	if (locale === "pl") return pl_onboarding_resume_upload_title(inputs)
	if (locale === "fi") return fi_onboarding_resume_upload_title(inputs)
	if (locale === "da") return da_onboarding_resume_upload_title(inputs)
	if (locale === "sv") return sv_onboarding_resume_upload_title(inputs)
	return en_onboarding_resume_upload_title(inputs)
});